import { Checkbox, CheckboxProps, Flex, Spinner } from '@chakra-ui/react';
import { ListItem } from 'app/components/ChakraTableList';
import { UpdateSharedLinkEffectData } from 'app/store/Shares/effects.types';
import { useIsMounted } from 'app/utils/hooks';
import { useState } from 'react';
import { Link } from 'types/api.types';
import { GenericObject } from 'types/generic.types';
import { SharedLink } from 'types/shares.types';

interface ShareLinkToggleProps {
  propKey: 'download' | 'lyrics' | 'credits';
  link: SharedLink;
  isRevoked: boolean;
  data: UpdateSharedLinkEffectData['data'];
  updateSharedLink: (
    link: Link,
    data: UpdateSharedLinkEffectData['data'],
    linkGuid?: string
  ) => Promise<SharedLink | void>;
}

export const ShareLinkToggle = ({
  propKey,
  link,
  isRevoked,
  data,
  updateSharedLink,
}: ShareLinkToggleProps) => {
  const isMounted = useIsMounted();
  const [isLoading, setIsLoading] = useState<GenericObject<boolean>>({});

  const isChecked = () =>
    propKey === 'download'
      ? link.downloadable
      : propKey === 'credits'
      ? link.creditsShared
      : link.lyricsShared;

  return (
    <ListItem>
      {!isLoading[link.guid] ? (
        <Flex
          alignItems="center"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <Checkbox
            isDisabled={isRevoked}
            isChecked={isChecked()}
            inputProps={
              {
                'data-testid': `share-link-${propKey}`,
              } as CheckboxProps['inputProps']
            }
            p={0}
            onChange={async (e) => {
              e.stopPropagation();
              if (link._links.updateShare) {
                try {
                  setIsLoading({ [link.guid]: true });
                  await updateSharedLink(
                    link._links.updateShare,
                    data,
                    link.guid
                  );
                } catch (e) {
                  // proceed
                } finally {
                  if (isMounted()) {
                    setIsLoading({ [link.guid]: false });
                  }
                }
              }
            }}
          />
        </Flex>
      ) : (
        <Spinner data-testid={`shareLink-${propKey}-loading`} size="md" />
      )}
    </ListItem>
  );
};
